import React from "react";
import { reducer, initialState, WizardState, WizardAction } from "./reducer";

type ContextValue = {
  state: WizardState;
  dispatch: React.Dispatch<WizardAction>;
};

const SubscriberSyncUploadContext = React.createContext<ContextValue | undefined>(undefined);

export const SubscriberSyncUploadProvider = ({
  children,
  initialState: initialOverride,
}: {
  children: React.ReactNode;
  initialState?: WizardState;
}) => {
  const [state, dispatch] = React.useReducer(reducer, initialOverride ?? initialState);

  return (
    <SubscriberSyncUploadContext.Provider value={{ state, dispatch }}>
      {children}
    </SubscriberSyncUploadContext.Provider>
  );
};

export function useSubscriberSyncUpload(): ContextValue {
  const ctx = React.useContext(SubscriberSyncUploadContext);
  if (!ctx) {
    throw new Error(
      "useSubscriberSyncUpload must be used within a SubscriberSyncUploadProvider",
    );
  }
  return ctx;
}
